import { withNamespace } from 'shared/lib';

const Title = ({ children }) => {
  return <div className='title-area'>{children}</div>;
};

const Main = () => {
  return (
    <h2 className='header-tit-02' style={{ marginBottom: '8px' }}>
      동의서를 작성하거나
      <br />
      제출한 동의서를 확인해 주세요
    </h2>
  );
};

const Sub = () => {
  return (
    <span className='sub-tit-01'>
      제출한 동의서는 <b>입원 기간 중에만</b> 확인할 수 있어요.
    </span>
  );
};

export default withNamespace(Title, {
  Main,
  Sub,
});
